import api from "@/lib/api";

export async function syncGoogleEvents(onProgress = () => {}) {
  let after = "";
  const totals = { sincronizados: 0, pendentes: 0, total: 0 };
  do {
    const { data } = await api.post("/integracoes/google/sincronizar", null, { params: { after } });
    for (const key of Object.keys(totals)) totals[key] += data[key] || 0;
    after = data.next_cursor || "";
    onProgress({ ...totals });
  } while (after);
  return totals;
}
